import axios from 'axios'
import { SUKL_USERS_URL } from './settings'

export type iUserData = {
  osobaID: number, // 0
  jmena: string,
  prijmeni: string,
  datovaSchranka: string,
  datumNarozeni: string,
  adresa: {
    ulice: string,
    cisloPopisne: string,
    cisloOrientacni: string,
    obec: string,
    castObce: string,
    psc: string
  }
}

// TODO  error interface
class SuklUsersApi {
  api = axios.create({
    baseURL: SUKL_USERS_URL,
  })

  getUserDetail = (extId: string) =>
    this.api.get<iUserData>(`/osoba/${extId}`)
      .then(res => res.data)

  getUserDetailWithRetry = async (
    extId: string,
    maxRetries: number = 3
  ): Promise<iUserData> => {
    for (let i = 1; i <= maxRetries; i++) {
      try {
        const data = await this.getUserDetail(extId)
        return data
      } catch (error) {
        if (i === maxRetries) throw error
        await new Promise(resolve => setTimeout(resolve, 2000))
      }
    }
    throw new Error('Unexpected error')
  }

}

export default new SuklUsersApi()
